// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"b12a2534","898":"6ad899ae"}[chunkId] + ".chunk.js";
};